import { Base } from '@studiometa/js-toolkit';
import {
  transition,
  addClass,
  addStyle,
  removeStyle,
  nextFrame,
} from '@studiometa/js-toolkit/utils';

/**
 * TabSelect component
 */
export default class TabSelect extends Base {
  static config = {
    name: 'TabSelect',
    refs: ['select', 'tabs[]'],
  };

  current = 0;

  /**
   * Mounted
   */
  mounted() {
    this.current = Number.parseInt(this.$refs?.select?.value ?? '0', 10);

    this.$refs.tabs.forEach((tab, index) => {
      if (index === this.current) {
        tab.removeAttribute('aria-hidden');
        removeStyle(tab, {
          visibility: 'hidden',
        });
      } else {
        tab.setAttribute('aria-hidden', 'true');
        addStyle(tab, {
          visibility: 'hidden',
          pointerEvents: 'none',
        });
        addClass(tab, 'opacity-0 translate-y-8');
      }
    });
  }

  /**
   * On select change
   */
  onSelectChange() {
    this.goTo(Number.parseInt(this.$refs?.select?.value ?? '0', 10));
  }

  /**
   * Go to tab
   * @param {number} next
   */
  async goTo(next) {
    if (!this.$refs.tabs[next]) {
      return;
    }

    const currentTab = this.$refs.tabs[this.current];
    const nextTab = this.$refs.tabs[next];

    await transition(
      currentTab,
      {
        active: 'transition duration-500 ease-out',
        to: 'opacity-0 translate-y-8',
      },
      'keep',
    );

    await nextFrame(() => {
      currentTab.setAttribute('aria-hidden', 'true');
      addStyle(currentTab, {
        visibility: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
      });

      nextTab.removeAttribute('aria-hidden');
      removeStyle(nextTab, {
        visibility: 'hidden',
        pointerEvents: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
      });
    });

    await transition(
      nextTab,
      {
        from: 'opacity-0 translate-y-8',
        active: 'transition duration-500 ease-out',
      },
      'keep',
    );

    this.current = next;
  }
}
